import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onSave: '&',
        onClose: '&',
        user: '=',
        trainingTime: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'occurrence.Sign participation' | translate }}</h2>
        </div>
        <div class="modal-body">
            <alert-error ng-if="vm.signatureMissing">{{ 'occurrence.Signature missing' | translate }}</alert-error>
            <div class="form">
                <div class="row">
                    <span class="label">{{ 'occurrence.Participator' | translate }}:</span>
                    <div class="items"><span class="text">{{ vm.user.displayName }}</span></div>
                </div>
                <signature-pad accept="vm.accept" clear="clear" height="220" width="568"></signature-pad>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li ng-if="vm.loading">{{ 'general.Loading' | translate }}...</li>
                <li ng-if="!vm.loading">
                    <a class="btn main" ng-click="vm.sign()">{{ 'occurrence.Sign' | translate }}</a>
                </li>
                <li ng-if="!vm.loading">
                    <a class="btn discrete" ng-click="clear()">{{ 'occurrence.Clear signature' | translate }}</a>
                </li>
                <li ng-if="!vm.loading" class="f-right" >
                    <button class="btn discrete" type="button" ng-click="vm.onClose()">{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})

export default class {
    constructor (OccurrenceResource) {
        this.OccurrenceResource = OccurrenceResource;
        this.signatureMissing = false;
    }

    sign () {
        this.loading = true;
        if (this.accept().isEmpty || !this.accept().dataUrl) {
            this.signatureMissing = true;
            this.loading = false;
        }
        else {
            this.OccurrenceResource.setTrainingTimeParticipants(
                { id: this.trainingTime.id },
                [{
                    userId: this.user.userId,
                    isParticipated: 1,
                    signature: this.accept().dataUrl
                }]
            ).$promise
                .then(() => {
                    this.loading = false;
                    this.onSave();
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/signParticipation/index.js